const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoShort2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 47",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    id: "svg_5",
    "data-name": "svg 5",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,36.8l-1-6.8a5.18,5.18,0,0,0-5.1-4.6H26.5a.68.68,0,0,1-.7-.7V22.1l.8.8A3.63,3.63,0,0,0,29.2,24h3.2a2.2,2.2,0,1,0,0-4.4H30a.76.76,0,0,1-.5-.2l-3.1-3.1a3.63,3.63,0,0,0-2.6-1.1H22a2.22,2.22,0,0,0-2.2,2.2v8.8A5.23,5.23,0,0,0,25,31.4h4.6a.68.68,0,0,1,.7.7l1.2,5.7a3,3,0,0,0,2.9,2.5,3.26,3.26,0,0,0,3.1-3.5Z",
    style: {
      fill: "#5b5eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,9.2a4.4,4.4,0,1,1-4.4-4.4A4.44,4.44,0,0,1,27.2,9.2Z",
    style: {
      fill: "#5b5eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,32.9a.75.75,0,0,0-.9.4,8.09,8.09,0,1,1-8.9-10.7c.4-.1.7-.4.6-.8s-.4-.7-.8-.6A9.57,9.57,0,1,0,28.2,33.8a.87.87,0,0,0-.6-.9Z",
    style: {
      fill: "#5b5eff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoShort2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-short-2.d821e1d3829624a9019c92be6bde21ad.svg";